import React from "react";

const defaultTurnoverData = [
  {
    parameter: "Environmental and social parameters relevant to the product",
    percentage: "",
  },
  { parameter: "Safe and responsible usage", percentage: "" },

  { parameter: "Recycling and/or safe disposal", percentage: "" },
];

const TurnoverParameterTable = ({
  turnoverData = defaultTurnoverData,
  setTurnoverData,
}) => {
  const handleChange = (index, value) => {
    const updated = [...turnoverData];
    updated[index].percentage = value;
    setTurnoverData(updated);
  };

  const cellLeft = {
    border: "1px solid #000",
    padding: "15px",
    verticalAlign: "top",
    textAlign: "left",
    fontWeight: "bold",
    width: "50%",
  };

  const cellRight = {
    border: "1px solid #000",
    padding: "15px",
    verticalAlign: "top",
    textAlign: "center",
    width: "50%",
  };

  const header = {
    border: "1px solid #000",
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    padding: "15px",
    textAlign: "center",
    width: "50%",
  };

  const inputStyle = {
    width: "50%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
    textAlign: "left",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header}></th>
            <th style={header}>As a percentage to total turnover</th>
          </tr>
        </thead>
        <tbody>
          {turnoverData.map((row, index) => (
            <tr key={index}>
              <td style={cellLeft}>{row.parameter}</td>
              <td style={cellRight}>
                <input
                  type="text"
                  placeholder="%"
                  value={row.percentage}
                  onChange={(e) => handleChange(index, e.target.value)}
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TurnoverParameterTable;
